module.exports = "render() {\n  return (\n    <div id='example' className='red-text'}>\n      CSS Example\n    </div>\n  );\n}\n"